import type { Props as DetailViewProps } from '@/views/effort/DetailView.vue'
import type { _RouteLocationBase } from 'vue-router'

const EntryDetailView = async () => import('@/views/timeplanning/TimePlanningEntryDetailView.vue')
const CaptureView = async () => import('@/views/timeplanning/TimePlanningCaptureView.vue')

/** @type {import('vue-router').RouteRecordRaw[]} */
export default [
  {
    path: '/time-planning/entry/:id',
    name: 'time_planning_entry_details',
    component: EntryDetailView,
    meta: { title: 'Zeitplanungseintrag' },
    props: (route: _RouteLocationBase): DetailViewProps => {
      return { id: Number(route.params.id) }
    }
  },
  {
    meta: { title: 'Zeitplanungseintrag bearbeiten' },
    path: '/time-planning/capture/edit/:id',
    name: 'time_planning_capture_edit',
    component: CaptureView,
    props: (route) => {
      return { edit: Number(route.params.id) }
    }
  },
  {
    meta: { title: 'Zeitplanungseintrag duplizieren' },
    path: '/time-planning/capture/duplicate/:id',
    name: 'time_planning_capture_duplicate',
    component: CaptureView,
    props: (route) => {
      return { duplicationSource: Number(route.params.id) }
    }
  }
]
